<template>
  <span v-if="href" class="doc-link">
    <a :href="href" target="_blank" rel="noopener noreferrer" :title="title">
      <i class="ti ti-help-circle me-1"></i>
      <span v-if="showText">{{ textToShow }}</span>
    </a>
  </span>
</template>

<script>
import { getDocLink } from "@/data/docs";

export default {
  name: 'DocLink',
  props: {
    docKey: { type: String, default: '' },
    url: { type: String, default: '' },
    text: { type: String, default: '' },
    title: { type: String, default: 'Открыть документацию' },
    showText: { type: Boolean, default: true }
  },
  computed: {
    href() {
      return this.url || (this.docKey ? getDocLink(this.docKey) : '');
    },
    textToShow() {
      return this.text || 'Документация';
    }
  }
}
</script>

<style scoped>
.doc-link a {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}
.doc-link a:hover i {
  color: #0d6efd;
}
</style>
